import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './index.js';
import dateTimeFormats from '@/language/date-time-localization/dateTimeFormats';

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages,
  dateTimeFormats
});
